"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import "../styles/Relatorio.css"
import { FaFileDownload, FaFileAlt, FaMap, FaChartLine, FaSpinner } from "react-icons/fa"

const API = "https://api.ticketdovaqueiro.com"

const RelatorioAdmin = () => {
  const [eventos, setEventos] = useState([])
  const [categorias, setCategorias] = useState([])
  const [eventoSelecionado, setEventoSelecionado] = useState("")
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("")
  const [loading, setLoading] = useState(false)
  const [senhaInicial, setSenhaInicial] = useState("")
  const [senhaFinal, setSenhaFinal] = useState("")
  const [jsonImportado, setJsonImportado] = useState(null)
  const [senhasExcluidas, setSenhasExcluidas] = useState("")

  // Estado do painel financeiro de parcelamentos
  const [financeiroParcelado, setFinanceiroParcelado] = useState(null)
  const [loadingFinanceiro, setLoadingFinanceiro] = useState(false)
  const [erroFinanceiro, setErroFinanceiro] = useState("")
  const [mostrarFinanceiro, setMostrarFinanceiro] = useState(false)

  // 🔄 Carregar eventos do dono com autenticação
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        setLoading(true)
        const response = await axios.get(`${API}/api/events`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        setEventos(response.data)
        setLoading(false)
      } catch (error) {
        console.error("Erro ao buscar eventos:", error)
        setLoading(false)
      }
    }
    fetchEventos()
  }, [])

  // 🔄 Carregar categorias com base no evento
  useEffect(() => {
    const fetchCategorias = async () => {
      if (eventoSelecionado) {
        try {
          setLoading(true)
          const response = await axios.get(
            `${API}/api/events/${eventoSelecionado}/categorias`,
            { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } },
          )
          setCategorias(response.data)
          setLoading(false)
        } catch (error) {
          console.error("Erro ao buscar categorias:", error)
          setLoading(false)
        }
      }
    }
    fetchCategorias()
  }, [eventoSelecionado])

  // 📥 Baixar relatório
  const handleBaixarRelatorio = () => {
    if (!eventoSelecionado || !categoriaSelecionada) {
      alert("Selecione o evento e a categoria!")
      return
    }
    window.open(
      `${API}/api/relatorios/gerar-pdf?eventoId=${eventoSelecionado}&categoria=${categoriaSelecionada}`,
      "_blank",
    )
  }

  const handleBaixarRelatorioJuizLocutor = () => {
    if (!eventoSelecionado || !categoriaSelecionada) {
      alert("Selecione o evento e a categoria!")
      return
    }
    window.open(
      `${API}/api/relatorios/gerar-pdf-juiz-locutor?eventoId=${eventoSelecionado}&categoria=${categoriaSelecionada}`,
      "_blank",
    )
  }

  const handleBaixarRelatorioUnificado = () => {
    if (!eventoSelecionado) {
      alert("Selecione um evento para baixar o relatório Antecipado/Presencial!")
      return
    }

    const url = `${API}/api/relatorios/gerar-relatorio-geral-unificado?eventoId=${eventoSelecionado}`
    window.open(url, "_blank")
  }

  const handleBaixarVendasCategoria = (formato) => {
    if (!eventoSelecionado || !categoriaSelecionada) {
      alert("Selecione o evento e a categoria para gerar o relatório!")
      return
    }
    const params = new URLSearchParams({ eventoId: eventoSelecionado, categoria: categoriaSelecionada })
    const rota = formato === "pdf" ? "exportar-vendas-categoria-pdf" : "exportar-vendas-categoria-csv"
    window.open(`${API}/api/relatorios/${rota}?${params.toString()}`, "_blank")
  }

  const handleBaixarPedidosPorRepresentacao = () => {
    if (!eventoSelecionado) {
      alert("Selecione um evento para gerar o relatório!")
      return
    }
    const params = new URLSearchParams({ eventoId: eventoSelecionado, versao: String(Date.now()) })
    window.open(`${API}/api/relatorios/exportar-pedidos-representacao-v2-pdf?${params.toString()}`, "_blank")
  }

  const handleBaixarRelatorioCompleto = () => {
    if (!eventoSelecionado || !senhaInicial || !senhaFinal) {
      alert("Selecione o evento e preencha a senha inicial e final!")
      return
    }
    const url = `${API}/api/relatorios/gerar-pdf-completo?eventoId=${eventoSelecionado}&senhaInicial=${senhaInicial}&senhaFinal=${senhaFinal}`
    window.open(url, "_blank")
  }

  const handleBaixarRelatorioCompartilhado = () => {
    if (!eventoSelecionado || !senhaInicial || !senhaFinal) {
      alert("Selecione o evento e informe a senha inicial e final!")
      return
    }
    const url = `${API}/api/relatorios/gerar-pdf-juiz-locutor-compartilhado?eventoId=${eventoSelecionado}&senhaInicial=${senhaInicial}&senhaFinal=${senhaFinal}`
    window.open(url, "_blank")
  }

  const handleBaixarRelatorioCompartilhadoVendidas = () => {
    if (!eventoSelecionado || !senhaInicial || !senhaFinal) {
      alert("Selecione o evento e informe a senha inicial e final!")
      return
    }
    const url = `${API}/api/relatorios/gerar-pdf-juiz-locutor-compartilhado-vendidas?eventoId=${eventoSelecionado}&senhaInicial=${senhaInicial}&senhaFinal=${senhaFinal}`
    window.open(url, "_blank")
  }

  const handleBaixarMapaVisual = () => {
    if (!eventoSelecionado || !senhaInicial || !senhaFinal) {
      alert("Selecione o evento e informe a senha inicial e final!")
      return
    }
    if (parseInt(senhaInicial) > parseInt(senhaFinal)) {
      alert("A senha final deve ser maior que a senha inicial!")
      return
    }
    const url = `${API}/api/relatorios/gerar-mapa-senhas?eventoId=${eventoSelecionado}&senhaInicial=${senhaInicial}&senhaFinal=${senhaFinal}`
    window.open(url, "_blank")
  }

  const handleExportarSenhasCSVIntervalo = () => {
    if (!eventoSelecionado || !senhaInicial || !senhaFinal) {
      alert("Selecione o evento e informe a senha inicial e final!")
      return
    }
    const inicio = Number(senhaInicial)
    const fim = Number(senhaFinal)
    if (!Number.isInteger(inicio) || !Number.isInteger(fim) || fim < inicio) {
      alert("Informe um intervalo de numeração válido!")
      return
    }
    const params = new URLSearchParams({
      eventoId: eventoSelecionado,
      senhaInicial: String(inicio),
      senhaFinal: String(fim),
    })
    window.open(`${API}/api/relatorios/exportar-senhas-csv-intervalo?${params.toString()}`, "_blank")
  }

  const handleImportarJSON = (event) => {
    const file = event.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target.result)
        if (!Array.isArray(json.pedidos)) {
          alert("Arquivo inválido: estrutura esperada { pedidos: [] }")
          return
        }
        setJsonImportado(json)
        alert("Arquivo JSON importado com sucesso!")
      } catch (err) {
        console.error("Erro ao importar JSON:", err)
        alert("Erro ao importar o arquivo JSON.")
      }
    }
    reader.readAsText(file)
  }

  const handleGerarRelatorioImportado = async () => {
    if (!jsonImportado || !Array.isArray(jsonImportado.pedidos)) {
      alert("Nenhum JSON importado.")
      return
    }

    const senhasExcluidasArray = senhasExcluidas
      .split(',')
      .map(s => parseInt(s.trim()))
      .filter(n => !isNaN(n))

    const payload = { ...jsonImportado, senhasExcluidas: senhasExcluidasArray }

    try {
      const res = await fetch(`${API}/api/relatorios/gerar-relatorio-importado`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })

      if (!res.ok) throw new Error("Falha na geração do PDF")

      const blob = await res.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = `Relatorio-Importado-${Date.now()}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.error("Erro ao gerar relatório importado:", err)
      alert("Erro ao gerar relatório.")
    }
  }

  // ─── Relatório Financeiro de Parcelamentos ────────────────────────────────

  const handleVerFinanceiroParcelado = async () => {
    if (!eventoSelecionado) {
      alert("Selecione um evento primeiro!")
      return
    }

    setLoadingFinanceiro(true)
    setErroFinanceiro("")
    setMostrarFinanceiro(true)
    setFinanceiroParcelado(null)

    try {
      const { data } = await axios.get(
        `${API}/api/relatorios/financeiro/${eventoSelecionado}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      )
      setFinanceiroParcelado(data)
    } catch (err) {
      console.error("Erro ao carregar financeiro parcelado:", err)
      setErroFinanceiro("Não foi possível carregar o relatório financeiro.")
    } finally {
      setLoadingFinanceiro(false)
    }
  }

  const handleExportarCSVParcelados = () => {
    if (!eventoSelecionado) {
      alert("Selecione um evento primeiro!")
      return
    }
    window.open(
      `${API}/api/relatorios/parcelados/${eventoSelecionado}/exportar`,
      "_blank"
    )
  }

  // Formata valor monetário
  const fmt = (v) => `R$ ${Number(v || 0).toFixed(2)}`

  // Cor do badge de status do parcelamento
  const statusStyle = {
    em_andamento: { background: "#dbeafe", color: "#1d4ed8" },
    concluido:    { background: "#dcfce7", color: "#15803d" },
    inadimplente: { background: "#fee2e2", color: "#b91c1c" },
    cancelado:    { background: "#f3f4f6", color: "#6b7280" },
  }
  const statusLabel = {
    em_andamento: "Em andamento",
    concluido:    "Concluído",
    inadimplente: "Inadimplente",
    cancelado:    "Cancelado",
  }

  return (
    <div className="relatorio-container">
      <h2 className="relatorio-titulo">📄 Relatório de Pedidos e Mapas</h2>

      <div className="form-group">
        <label>Evento</label>
        <select value={eventoSelecionado} onChange={(e) => {
          setEventoSelecionado(e.target.value)
          setMostrarFinanceiro(false)
          setFinanceiroParcelado(null)
        }} disabled={loading}>
          <option value="">Selecione um evento</option>
          {eventos.map((evento) => (
            <option key={evento._id} value={evento._id}>{evento.nome}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Categoria (Opcional para alguns PDFs)</label>
        <select
          value={categoriaSelecionada}
          onChange={(e) => setCategoriaSelecionada(e.target.value)}
          disabled={!categorias.length || loading}
        >
          <option value="">Selecione uma categoria</option>
          {categorias.map((categoria) => (
            <option key={categoria._id} value={categoria.nome}>{categoria.nome}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Senha Inicial</label>
        <input type="number" value={senhaInicial} onChange={(e) => setSenhaInicial(e.target.value)} />
      </div>

      <div className="form-group">
        <label>Senha Final</label>
        <input type="number" value={senhaFinal} onChange={(e) => setSenhaFinal(e.target.value)} />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "20px" }}>
        <div className="relatorio-destaque-unificado">
          <div className="relatorio-destaque-info">
            <span className="relatorio-destaque-tag">FINANCEIRO GERAL</span>
            <strong>Relatório Antecipado/Presencial</strong>
            <small>Baixa o PDF unificado separando vendas do site e vendas presenciais do programa.</small>
          </div>

          <button
            className="botao-relatorio botao-relatorio-unificado"
            onClick={handleBaixarRelatorioUnificado}
            disabled={!eventoSelecionado || loading}
          >
            <FaFileDownload size={20} />
            Baixar Relatório Antecipado/Presencial
          </button>
        </div>

        {/* ── NOVO: Relatório Financeiro de Parcelamentos ──────────────────── */}
        <button
          className="botao-relatorio"
          style={{ backgroundColor: "#7c3aed", color: "#fff", fontWeight: 600 }}
          onClick={handleVerFinanceiroParcelado}
          disabled={!eventoSelecionado || loading}
        >
          <FaChartLine size={18} />
          Ver Financeiro de Parcelamentos (Realizado vs A Receber)
        </button>

        <button
          className="botao-relatorio"
          style={{ backgroundColor: "#2563eb", color: "#fff" }}
          onClick={handleBaixarMapaVisual}
          disabled={!eventoSelecionado || !senhaInicial || !senhaFinal || loading}
        >
          <FaMap size={18} />
          Baixar Mapa Visual (Tabela de Blocos)
        </button>

        <button
          className="botao-relatorio"
          onClick={handleExportarSenhasCSVIntervalo}
          disabled={!eventoSelecionado || !senhaInicial || !senhaFinal || loading}
        >
          <FaFileDownload size={18} />
          Exportar CSV de Senhas (Todas as Categorias do Intervalo)
        </button>

        <button
          className="botao-relatorio"
          onClick={handleBaixarRelatorio}
          disabled={!eventoSelecionado || !categoriaSelecionada || loading}
        >
          <FaFileDownload size={18} />
          Baixar Relatório Financeiro/Lista (Requer Categoria)
        </button>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button
            className="botao-relatorio"
            onClick={() => handleBaixarVendasCategoria("csv")}
            disabled={!eventoSelecionado || !categoriaSelecionada || loading}
          >
            <FaFileDownload size={18} />
            Vendas da Categoria (CSV)
          </button>
          <button
            className="botao-relatorio"
            onClick={() => handleBaixarVendasCategoria("pdf")}
            disabled={!eventoSelecionado || !categoriaSelecionada || loading}
          >
            <FaFileAlt size={18} />
            Vendas da Categoria (PDF)
          </button>
        </div>

        <button
          className="botao-relatorio"
          onClick={handleBaixarPedidosPorRepresentacao}
          disabled={!eventoSelecionado || loading}
        >
          <FaFileAlt size={18} />
          Relatório de Senhas por Representação (PDF)
        </button>

        <button
          className="botao-locutorjuiz"
          onClick={handleBaixarRelatorioJuizLocutor}
          disabled={!eventoSelecionado || !categoriaSelecionada || loading}
        >
          <FaFileAlt size={18} />
          Gerar PDF Juiz/Locutor (Requer Categoria)
        </button>

        <button
          className="botao-relatorio"
          onClick={handleBaixarRelatorioCompleto}
          disabled={!eventoSelecionado || !senhaInicial || !senhaFinal || loading}
        >
          <FaFileDownload size={18} />
          Relatório Mestre (Com Senhas Vazias Inclusas)
        </button>

        <button
          className="botao-relatorio"
          onClick={handleBaixarRelatorioCompartilhado}
          disabled={!eventoSelecionado || !senhaInicial || !senhaFinal || loading}
        >
          <FaFileDownload size={18} />
          Baixar Relatório Juiz/Locutor (Todas Categorias Mescladas)
        </button>

        <button
          className="botao-relatorio"
          onClick={handleBaixarRelatorioCompartilhadoVendidas}
          disabled={!eventoSelecionado || !senhaInicial || !senhaFinal || loading}
        >
          <FaFileDownload size={18} />
          Juiz/Locutor Compartilhado (Apenas as Vendidas)
        </button>
      </div>

      {/* ── PAINEL FINANCEIRO DE PARCELAMENTOS ──────────────────────────────── */}
      {mostrarFinanceiro && (
        <div style={{
          marginTop: 32,
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          padding: 24,
          background: "#fafafa"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <h3 style={{ margin: 0, color: "#7c3aed" }}>Financeiro de Parcelamentos</h3>
            <button
              onClick={handleExportarCSVParcelados}
              style={{
                background: "#7c3aed", color: "#fff", border: "none",
                borderRadius: 6, padding: "6px 14px", cursor: "pointer",
                display: "flex", alignItems: "center", gap: 6, fontSize: 13
              }}
            >
              <FaFileDownload size={14} /> Exportar CSV
            </button>
          </div>

          {loadingFinanceiro && (
            <div style={{ textAlign: "center", padding: 32, color: "#6b7280" }}>
              <FaSpinner style={{ animation: "spin 1s linear infinite", fontSize: 28 }} />
              <p>Carregando...</p>
            </div>
          )}

          {erroFinanceiro && (
            <p style={{ color: "#b91c1c", background: "#fee2e2", padding: 12, borderRadius: 8 }}>
              {erroFinanceiro}
            </p>
          )}

          {financeiroParcelado && !loadingFinanceiro && (
            <>
              {/* Cards de resumo */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 24 }}>
                {[
                  { label: "Total de vendas", valor: financeiroParcelado.resumo.totalVendas, isMoney: false, cor: "#374151" },
                  { label: "Receita realizada", valor: fmt(financeiroParcelado.resumo.receitaRealizada), isMoney: true, cor: "#15803d" },
                  { label: "A receber (parcelas)", valor: fmt(financeiroParcelado.resumo.receitaAReceber), isMoney: true, cor: "#1d4ed8" },
                  { label: "Receita total prevista", valor: fmt(financeiroParcelado.resumo.receitaTotal), isMoney: true, cor: "#7c3aed" },
                ].map((card) => (
                  <div key={card.label} style={{
                    background: "#fff", border: "1px solid #e5e7eb",
                    borderRadius: 10, padding: "14px 16px"
                  }}>
                    <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 4px" }}>{card.label}</p>
                    <p style={{ fontSize: 22, fontWeight: 600, color: card.cor, margin: 0 }}>{card.valor}</p>
                  </div>
                ))}
              </div>

              {/* Resumo por tipo de pagamento */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24 }}>
                <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, padding: "14px 16px" }}>
                  <p style={{ fontWeight: 600, margin: "0 0 6px", fontSize: 14 }}>Pagamentos únicos</p>
                  <p style={{ margin: 0, fontSize: 13, color: "#374151" }}>
                    {financeiroParcelado.pagamentosUnicos.quantidade} vendas —{" "}
                    <strong>{fmt(financeiroParcelado.pagamentosUnicos.receita)}</strong>
                  </p>
                </div>
                <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, padding: "14px 16px" }}>
                  <p style={{ fontWeight: 600, margin: "0 0 6px", fontSize: 14 }}>Boletos parcelados</p>
                  <p style={{ margin: "0 0 4px", fontSize: 13, color: "#374151" }}>
                    {financeiroParcelado.parcelamentos.total} inscrições ·{" "}
                    <span style={{ color: "#15803d" }}>{financeiroParcelado.parcelamentos.concluidos} concluídos</span> ·{" "}
                    <span style={{ color: "#1d4ed8" }}>{financeiroParcelado.parcelamentos.emAndamento} em andamento</span> ·{" "}
                    <span style={{ color: "#b91c1c" }}>{financeiroParcelado.parcelamentos.inadimplentes} inadimplentes</span>
                  </p>
                  <p style={{ margin: 0, fontSize: 13, color: "#374151" }}>
                    Realizado: <strong style={{ color: "#15803d" }}>{fmt(financeiroParcelado.parcelamentos.receitaRealizada)}</strong>
                    {" "}· A receber: <strong style={{ color: "#1d4ed8" }}>{fmt(financeiroParcelado.parcelamentos.receitaAReceber)}</strong>
                  </p>
                </div>
              </div>

              {/* Tabela de detalhe por parcelamento */}
              {financeiroParcelado.detalheParcelados?.length > 0 ? (
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: "#7c3aed", color: "#fff" }}>
                        {["Vaqueiro", "Categoria", "Parcelas", "Realizado", "A Receber", "Próx. vencimento", "Status", "WhatsApp"].map(h => (
                          <th key={h} style={{ padding: "10px 12px", textAlign: "left", fontWeight: 500 }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {financeiroParcelado.detalheParcelados.map((d, i) => {
                        const proxVenc = d.proximoPagamento
                          ? new Date(d.proximoPagamento).toLocaleDateString("pt-BR")
                          : "—"
                        const st = statusStyle[d.status] || {}
                        return (
                          <tr key={d.pedidoParceladoId} style={{ background: i % 2 === 0 ? "#fff" : "#f9fafb" }}>
                            <td style={{ padding: "9px 12px" }}>{d.vaqueiro}</td>
                            <td style={{ padding: "9px 12px" }}>{d.categoria}</td>
                            <td style={{ padding: "9px 12px" }}>
                              {d.parcelasPagas}/{d.numeroParcelas}
                              {d.vencidas > 0 && (
                                <span style={{ color: "#b91c1c", marginLeft: 6, fontSize: 12 }}>
                                  ({d.vencidas} vencida{d.vencidas > 1 ? "s" : ""})
                                </span>
                              )}
                            </td>
                            <td style={{ padding: "9px 12px", color: "#15803d", fontWeight: 600 }}>
                              {fmt(d.realizadoNeste)}
                            </td>
                            <td style={{ padding: "9px 12px", color: "#1d4ed8" }}>
                              {fmt(d.aReceberNeste)}
                            </td>
                            <td style={{ padding: "9px 12px" }}>{proxVenc}</td>
                            <td style={{ padding: "9px 12px" }}>
                              <span style={{
                                ...st, padding: "3px 10px", borderRadius: 6,
                                fontSize: 12, fontWeight: 500
                              }}>
                                {statusLabel[d.status] || d.status}
                              </span>
                            </td>
                            <td style={{ padding: "9px 12px" }}>
                              {d.whatsapp ? (
                                <a
                                  href={`https://wa.me/55${d.whatsapp.replace(/\D/g, "")}?text=Olá ${d.vaqueiro}, sua parcela vence em ${proxVenc}. Acesse o boleto pelo app.`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#16a34a", fontSize: 18 }}
                                  title="Cobrar via WhatsApp"
                                >
                                  💬
                                </a>
                              ) : "—"}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p style={{ color: "#6b7280", textAlign: "center", padding: 24 }}>
                  Nenhum parcelamento encontrado para este evento.
                </p>
              )}
            </>
          )}
        </div>
      )}

      <hr style={{ marginTop: 30, marginBottom: 10 }} />

      <h3 style={{ marginBottom: "15px", color: "#333" }}>Opções Avançadas (Importação)</h3>

      <div className="form-group">
        <label>Importar Pedidos (JSON)</label>
        <input type="file" accept=".json" onChange={handleImportarJSON} />
      </div>

      <div className="form-group">
        <label>Senhas Excluídas na Importação (separadas por vírgula)</label>
        <input
          type="text"
          placeholder="Ex: 1001,1005,1009"
          value={senhasExcluidas}
          onChange={(e) => setSenhasExcluidas(e.target.value)}
        />
      </div>

      {jsonImportado && (
        <button className="botao-relatorio" onClick={handleGerarRelatorioImportado}>
          <FaFileDownload size={18} /> Gerar PDF dos Pedidos Importados
        </button>
      )}
    </div>
  )
}

export default RelatorioAdmin
